import { createStructuredSelector } from 'reselect';
import { fetchRAGState } from './RecommendGrantPageSelectors';

const selectSearchLoadMoreApi = (state) => {
  const { searchLoadMoreApi } = fetchRAGState(state);
  return searchLoadMoreApi;
};

const selectSearchCharityData = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.data;
};

const selectCharitySaved = (state) => {
  const { charitySaved } = fetchRAGState(state);
  return charitySaved;
};

const selectCurrentPageScroll = (state) => {
  const { currentPageScroll } = fetchRAGState(state);
  return currentPageScroll;
};

export const searchTableDerivedStates = createStructuredSelector({
  updatedCounterData: selectSearchLoadMoreApi,
  updatedSearchData: selectSearchCharityData,
  charitySaved: selectCharitySaved,
  currentPageScroll: selectCurrentPageScroll,
});
